// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    createHandlerChainRunnerOptionalParameter,
    Handler,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { generateAutoListService } from "@werner/App/Services/GenerateAutoListService";

type HandlerType = Handler<
    HasOnSuccess<string> & HasOnError,
    {
        apiResult: string;
    }
>;

export const RequestApi: HandlerType = async props => {
    try {
        props.apiResult = await generateAutoListService();
    } catch (err) {
        props.apiResult = "";
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [RequestApi, ExecuteOnSuccessCallback];

const generateAutoList = createHandlerChainRunnerOptionalParameter(chain, {}, "GenerateAutoList");
export default generateAutoList;
